var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductoRecomendadoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.737,
    height: 38.146,
    viewBox: "0 0 11.737 38.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-compact-up",
    d: "M18.416.155a1.467,1.467,0,0,1,1.315,0l17.606,8.8a1.467,1.467,0,1,1-1.315,2.623L19.073,3.11,2.125,11.582A1.467,1.467,0,1,1,.81,8.958L18.416.155Z",
    transform: "translate(11.737) rotate(90)",
    fill: "#003082",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductoRecomendadoArrow);
export default __webpack_public_path__ + "static/media/producto_recomendado_arrow.0ae283967b6773d29f57e4c4719bddb5.svg";
export { ForwardRef as ReactComponent };